var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfficialBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6824 1.87412C11.4048 0.496137 9.21313 0.534393 7.98438 1.95613C7.35815 2.68071 6.43656 3.08142 5.47955 3.04526C3.60175 2.97429 2.07905 4.5511 2.2155 6.42528C2.28505 7.38044 1.91674 8.31545 1.21446 8.96659C-0.163531 10.2442 -0.125275 12.4359 1.29646 13.6647C2.02104 14.2909 2.42176 15.2125 2.38559 16.1695C2.31462 18.0473 3.89143 19.57 5.76561 19.4335C6.72078 19.364 7.65579 19.7323 8.30692 20.4346C9.58454 21.8126 11.7762 21.7743 13.005 20.3526C13.6312 19.628 14.5528 19.2273 15.5098 19.2634C17.3876 19.3344 18.9103 17.7576 18.7739 15.8834C18.7043 14.9283 19.0726 13.9932 19.7749 13.3421C21.1529 12.0645 21.1146 9.8728 19.6929 8.64405C18.9683 8.01782 18.5676 7.09623 18.6038 6.13922C18.6747 4.26142 17.0979 2.73871 15.2238 2.87517C14.2686 2.94472 13.3336 2.57641 12.6824 1.87412ZM16.0772 8.65165C16.4531 8.24703 16.4298 7.61429 16.0252 7.23839C15.6206 6.86249 14.9878 6.88577 14.6119 7.29039L8.70143 13.6524L6.35475 11.2824C5.96616 10.89 5.33301 10.8868 4.94055 11.2754C4.5481 11.664 4.54497 12.2972 4.93356 12.6896L8.01382 15.8005C8.20552 15.9941 8.46791 16.1011 8.74033 16.0968C9.01275 16.0925 9.2716 15.9772 9.45704 15.7776L16.0772 8.65165Z",
    fill: "#F85A17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficialBadge);
export default __webpack_public_path__ + "static/media/official_badge.19f9675669317cd55aa679d3c3304354.svg";
export { ForwardRef as ReactComponent };